import { configuration } from "@faire/web/common/settings/declarations/configuration";

/**
 * Controls the debounce time for prefetching when user types in the search bar
 */
export const FE_LISP_PREFETCH_DEBOUNCE_250916 = configuration({
  name: "FE_LISP_PREFETCH_DEBOUNCE_250916",
  identifier: "RetailerTokenInSession",
  client: ["RETAILER"],
  defaultValue: 400,
  productArea: "SEARCH",
});
